(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product"]) return;
  try {
    
document.querySelectorAll('[data-scbd-recent-product]').forEach(function(node) {
  try {
    const product = JSON.parse(node.textContent);
    let history = JSON.parse(localStorage.getItem('theme-recent') || '{}');
    if (!history || typeof history !== 'object' || Array.isArray(history)) history = {};
    delete history[product.handle];
    history[product.handle] = { url: product.url, aspectRatio: product.aspectRatio, featuredImage: product.featuredImage };
    const handles = Object.keys(history);
    handles.slice(0, Math.max(0, handles.length - 20)).forEach(handle => delete history[handle]);
    localStorage.setItem('theme-recent', JSON.stringify(history));
  } catch (_) {}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["recently-viewed"]) return;
  try {
    
if (!customElements.get('scbd-recently-viewed')) {
  customElements.define('scbd-recently-viewed', class extends HTMLElement {
    async connectedCallback() {
      if (this.loaded) return;
      this.loaded = true;
      let history;
      try { history = JSON.parse(localStorage.getItem('theme-recent') || '{}'); }
      catch (_) { return; }
      if (!history || typeof history !== 'object') return;
      const limit = Math.min(10, Math.max(2, Number(this.dataset.limit) || 5));
      const handles = Object.keys(history).reverse().filter(handle => handle !== this.dataset.productHandle && handle !== 'undefined' && /^[a-z0-9][a-z0-9_-]*$/i.test(handle)).slice(0, limit);
      const root = (this.dataset.root || '/').replace(/\/?$/, '/');
      const results = await Promise.allSettled(handles.map(async handle => {
        const url = new URL(root + 'products/' + encodeURIComponent(handle), location.origin);
        url.searchParams.set('section_id', 'scbd-recent-card');
        const response = await fetch(url);
        if (!response.ok) return null;
        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        return html.querySelector('[data-scbd-recent-card] > .grid__item');
      }));
      if (!this.isConnected) return;
      const grid = this.querySelector('[data-scbd-recent-grid]');
      const cards = results.filter(result => result.status === 'fulfilled' && result.value).map(result => document.importNode(result.value, true));
      grid.replaceChildren(...cards);
      this.hidden = cards.length === 0;
      if (cards.length) this.dispatchEvent(new CustomEvent('shopify:section:load', { bubbles: true, detail: { sectionId: this.dataset.sectionId } }));
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scbd-collection-guide"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const enhanceGuide = (root) => {
      root.querySelectorAll('.scbd-collection-guide').forEach((guide) => {
        const toc = guide.querySelector('.scbd-collection-guide__toc');
        const content = guide.querySelector('.scbd-collection-guide__content');
        if (!content) return;
        content.querySelectorAll('table').forEach((table) => {
          if (table.parentElement.classList.contains('scbd-collection-guide__table-wrap')) return;
          const wrap = document.createElement('div');
          wrap.className = 'scbd-collection-guide__table-wrap';
          wrap.tabIndex = 0;
          wrap.setAttribute('role', 'region');
          const caption = table.querySelector('caption');
          const heading = guide.querySelector('h2');
          if (caption || heading) wrap.setAttribute('aria-label', (caption || heading).textContent.trim());
          table.removeAttribute('tabindex');
          table.before(wrap);
          wrap.appendChild(table);
        });
        if (!toc || toc.childElementCount) return;
        content.querySelectorAll('h2, h3').forEach((heading, index) => {
          if (!heading.id) heading.id = guide.id + '-topic-' + (index + 1);
          const link = document.createElement('a');
          link.href = '#' + heading.id;
          link.textContent = heading.textContent;
          toc.appendChild(link);
        });
        toc.hidden = !toc.childElementCount;
      });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => enhanceGuide(document), { once: true });
    else enhanceGuide(document);
    document.addEventListener('shopify:section:load', (event) => enhanceGuide(event.target));
    document.addEventListener('click', (event) => {
      if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      const link = event.target.closest('.scbd-collection-intro a[href^="#"], .scbd-collection-guide a[href^="#"]');
      if (!link) return;
      const target = document.getElementById(link.hash.slice(1));
      if (!target) return;
      event.preventDefault();
      history.replaceState(history.state, '', link.hash);
      if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
      target.focus({ preventScroll: true });
      target.scrollIntoView({ block: 'start', behavior: 'instant' });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scbd-loyalty"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', function (event) {
  const link = event.target.closest('.scbd-loyalty-home [data-loyalty-action="open"]');
  if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
  const host = document.getElementById('loloyal-launcher-box');
  const launcher = host?.shadowRoot?.querySelector('.loloyal-launcher') || host?.querySelector('.loloyal-launcher');
  if (!launcher) return;
  event.preventDefault();
  requestAnimationFrame(function () {
    if (!document.querySelector('.loloyal-iframe-page-open')) launcher.click();
  });
});

  } catch(e) { console.error(e); }
})();
})();
